/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class PostsRoute extends Route {
  // Services
  @service
  store;

  model() {
    let person = this.modelFor('people.person').person;
    return hash({
      person,
      posts: this.store.query('posts/post', {
        personId: person.id,
        include: 'reactions,comments',
      }),
    });
  }
}
